import { useEffect, useState } from "react";

export default function useIsDesktop(breakpoint = 1024) {
  const query = `(min-width: ${breakpoint}px)`;
  const getMatch = () =>
    typeof window !== "undefined"
      ? window.matchMedia(query).matches
      : true;

  const [isDesktop, setIsDesktop] = useState(getMatch());

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsDesktop(e.matches);

    // addEventListener fallback for Safari
    try { mql.addEventListener("change", onChange); }
    catch { mql.addListener(onChange); }

    setIsDesktop(mql.matches);

    return () => {
      try { mql.removeEventListener("change", onChange); }
      catch { mql.removeListener(onChange); }
    };
  }, [query]);

  return isDesktop;
}
